import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../models/IDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export interface IFilter {
    sales_Company?: number | null,
    sales_Branch?: number | null,
    recruiter_Company?: number | null,
    recruiter_Branch?: number | null,
}

interface IProps {
    filters: IFilter,
    setFilters: (filters: IFilter) => void,
    loading: boolean,
}

const schema = yup.object({
    sales_Company: yup.number().nullable(),
    sales_Branch: yup.number().nullable(),
    recruiter_Company: yup.number().nullable(),
    recruiter_Branch: yup.number().nullable(),
});

export const Filter = (props: IProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [companies2, setCompanies2] = useState<Array<ICompanyMastDropdown>>();
    const [branches2, setBranches2] = useState<Array<IBranchMastDropdown>>();
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const loadBranchesSales = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompaniesSales = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const loadBranchesRec = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches2(data);
        }
    }
    const loadCompaniesRec = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies2(data);
        }
    }
    useEffect(() => {
        loadCompaniesSales();
        loadBranchesSales();
        loadCompaniesRec();
        loadBranchesRec();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "sales_Company") {
                if (value.sales_Company != 0 && value.sales_Company != null) {
                    loadBranchesSales(value.sales_Company);
                } else {
                    loadBranchesSales();
                }
            }
            if (name === "recruiter_Company") {
                if (value.recruiter_Company != 0 && value.recruiter_Company != null) {
                    loadBranchesRec(value.recruiter_Company);
                } else {
                    loadBranchesRec();
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const onSubmit = (data: IFilter) => {
        props.setFilters(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown column={6} label="Sales Company" control={control} name="sales_Company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Sales Company" />
            <JVDropdown column={6} label="Sales Branch" control={control} name="sales_Branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Sales Branch" />
            <JVDropdown column={6} label="Recruiter Company" control={control} name="recruiter_Company" options={companies2} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Recruiter Company" />
            <JVDropdown column={6} label="Recruiter Branch" control={control} name="recruiter_Branch" options={branches2} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Recruiter Branch" />

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading}></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => reset({
                    sales_Company: null,
                    sales_Branch: null,
                    recruiter_Company: null,
                    recruiter_Branch: null,
                })} type="button"></Button>
            </div>
        </form>
    );
}